import React, { useState, useEffect } from 'react';
import { Divider, Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const HelloDeveloper = () => {
  const [params, setParams] = useState({});
  const [copied, setCopied] = useState(false);
  const [copiedParam, setCopiedParam] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlParams = {};

    searchParams.forEach((value, key) => {
      urlParams[key] = value;
    });

    setParams(urlParams);
    console.log('URL Parameters:', urlParams);
  }, [location]);

  const copyParams = () => {
    const paramsText = JSON.stringify(params, null, 2);
    navigator.clipboard
      .writeText(paramsText)
      .then(() => {
        setCopied(true);
        message.success('All parameters copied to clipboard!');
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        message.error('Failed to copy parameters');
      });
  };

  const copyIndividualParam = (key, value) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        setCopiedParam(key);
        message.success(`Parameter '${key}' copied to clipboard!`);
        setTimeout(() => setCopiedParam(null), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        message.error(`Failed to copy parameter '${key}'`);
      });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        color: '#555',
        fontWeight: 'normal',
      }}>
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/e/e8/Tesla_logo.png"
        alt="Tesla Logo"
        style={{ width: '100px', height: '100px', marginTop: '60px' }}
      />
      <h1>Hello, Developer!</h1>

      <div
        style={{
          marginTop: '60px',
          width: '80%',
          maxWidth: '520px',
          padding: '15px',
          backgroundColor: 'transparent',
        }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <h3 style={{ marginBottom: '10px' }}>URL Parameters</h3>
        </div>

        {Object.keys(params).length > 0 ? (
          <div>
            {Object.entries(params).map(([key, value]) => (
              <div
                key={key}
                onClick={() => copyIndividualParam(key, value)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  backgroundColor: 'transparent',
                  borderRadius: '4px',
                  marginBottom: '8px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'box-shadow 0.3s ease',
                  ':hover': {
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                  },
                }}>
                <div
                  style={{
                    maxWidth: '80%',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}>
                  <strong>{key}:</strong> {value}
                </div>
                <Button
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={() => copyIndividualParam(key, value)}
                  disabled={copiedParam === key}
                  style={{
                    flexShrink: 0,
                    marginLeft: '8px',
                    border: 'none',
                    backgroundColor: '#f9f9f9',
                  }}>
                  {copiedParam === key ? 'Copied!' : 'Copy'}
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              padding: '10px',
              borderRadius: '4px',
            }}>
            No parameters found
          </div>
        )}
      </div>

      <div
        style={{
          marginTop: 'auto',
          width: '90%',
          textAlign: 'center',
        }}>
        <Divider />
        <p>
          This page is hosted on{' '}
          <img
            src="/favicon.ico"
            alt="Toyota Logo"
            style={{ width: '14px', height: '14px' }}
          />
          <b> 和泰LINE@管理平台 </b>
        </p>
      </div>
    </div>
  );
};

export default HelloDeveloper;
